module.exports = __webpack_public_path__ + "media/civ3.8a9ee012.mp4";